import React, { Component } from 'react';
import CryptoJS from 'crypto-js';
import Logout from '../components/css/dark/img/theme-images/logout.svg';
import Compliance from '../components/css/dark/img/theme-images/compliance.svg';
import Bell from '../components/css/dark/img/bell_icon.svg';
import RxBell from '../components/css/dark/img/rx_bell_icon.svg';
import Close from '../components/css/dark/img/close_notification.png';
import Empty from '../components/css/dark/img/empty_notification.png';
import User from '../components/css/dark/img/gh_icon_new.png';
import RxUser from '../components/css/dark/img/rx_icon_new.png';
import { userService } from '../_services';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import * as signalR from '@aspnet/signalr';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr/dist/browser/signalr.js';
import Linkify from 'react-linkify';

class Header extends Component {

    constructor(props) {
        super(props);
        this.sidebarToggle = this.sidebarToggle.bind(this);
        let RoundPicName = "--";
        try {
            let JsonData = JSON.parse(localStorage.getItem('user'));
            let Username_Space_Split = JsonData.username.split(' ');
            var Username_Hyphen_Split = JsonData.username.split('-');
            if (Username_Space_Split.length > 1) {
                RoundPicName = JsonData.username.split(' ')[0].substring(JsonData.username.split(' ')[0], 1) + '' + JsonData.username.split(' ')[1].substring(JsonData.username.split(' ')[1], 1);
            }
            else if (Username_Hyphen_Split.length > 1) {
                RoundPicName = JsonData.username.split('-')[0].substring(JsonData.username.split('-')[0], 1) + '' + JsonData.username.split('-')[1].substring(JsonData.username.split('-')[1], 1);
            }
            else {
                RoundPicName = JsonData.username.substring(0, 1);
            }
        }
        catch (error) {
            RoundPicName = "--";
        }
        try {
            this.state = {
                // users: null,
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                userdata: JSON.parse(localStorage.getItem('user')),
                _RoundPicName: RoundPicName,
                notification: [],
                isAcknowledge: 0,
                secret: 'gc7cpraglkuqwcws8542cvqvE7DB1xzq5rmJFs696ZTJ',
            };
        }
        catch (error) { }
    }
    componentDidMount(event) {
        let global = this;
        $(document).on('click', function (e) {
            e.stopPropagation();
            $('.header-section .notification').hide();
        });
        $('.header-section .notification').on('click', function (e) {
            e.stopPropagation();
            $('.header-section .notification').show();
        });
        $('.header-section .bell-icon').on('click', function (e) {
            e.stopPropagation();
            if ($(window).width() < 1025) {
                $(".sidebar-section").animate({
                    left: -340 + 'px'
                }, 1000);
                $("body").removeClass('no-scroll');
            }
            global.bellClick();
        });
        try {
            let JsonData = JSON.parse(localStorage.getItem('user'));
            var roleEmail = JsonData.email;
            var roleType = JsonData.userrole;
            var roleId = JsonData.id;
            if (JsonData.isBrokerTypeUser) roleType = "Broker";
            this.GetLoggedInUserNotification(roleEmail, roleType, roleId);
        }
        catch (error) {
        }
    }
    componentDidUpdate() {
        this.getNotifications_SignalR();
        //this.ResetSession_UI_SignalR();
    }
    bellClick() {
        try {
            $('.header-section .notification').toggle();
            let userId = this.state.userdata.id;
            let userRole = this.state.userdata.userrole;
            let userEmail = this.state.userdata.email;
            if (this.state.userdata.isBrokerTypeUser) userRole = "Broker";
            if (this.state.isAcknowledge > 0) {
                this.changeAcknowledge(userId, userRole, userEmail);
            }
            // call get notification
            this.GetLoggedInUserNotification(userEmail, userRole, userId);
        }
        catch (error) { }
    }
    changeAcknowledge = (userId, userRole, userEmail) => {
        try {
            userService.NotificationAcknowledge(userId, userRole, userEmail).then(
                apidata => {
                    if (apidata[0].statuscode == 1) {
                        this.setState({ isAcknowledge: 0 });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    sidebarToggle() {
        try {
            $(".sidebar-section").animate({
                left: 0 + 'px'
            }, 1000);
            $("body").addClass('no-scroll');
        }
        catch (error) { }
    }
    deleteUser = () => {
        try {
            userService.logout();
            window.localStorage.removeItem("user");
            window.xl();
            window.location.href = window.location.origin;
        }
        catch (error) { }
    }
    clearAll = () => {
        try {
            this.setState({ notification: [] });
        }
        catch (error) { }
    }
    closeNotification = (e) => {
        try {
            let index = $(e.target).attr('data-index');
            let list = this.state.notification;
            list.splice(index, 1);
            this.setState({ notification: list });
        }
        catch (error) { }
    }
    getNotifications_SignalR = () => {
        let connection = new signalR.HubConnectionBuilder().withUrl("/notification", {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        }).build();
        try {
            connection.start().then(() => {
                connection.on("ReceiveMessage", (whemail, status, Note_UserType_, minset) => {
                    if (Note_UserType_.toLowerCase() != 'unknowntypeuser') {
                        let JsonData = JSON.parse(localStorage.getItem('user'));
                        var roleEmail = JsonData.email;
                        var roleType = JsonData.userrole;
                        var roleId = JsonData.id;
                        if (JsonData.isBrokerTypeUser) roleType = "Broker";
                        this.GetLoggedInUserNotification(roleEmail, roleType, roleId);
                    }
                });
            });
        }
        catch (err) {
        }
    }
    ResetSession_UI_SignalR = () => {
        let userAgent = window.navigator.userAgent;
        let connection = new signalR.HubConnectionBuilder().withUrl("/resetSession", {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        }).build();
        try {
            connection.start().then(() => {
                connection.on("ReceiveMessage", (Wh_Id, Email1,UA,UE) => {
                    let signalRDetection = localStorage.getItem('ch_cred_upl_dt');
                    if ((signalRDetection == null || signalRDetection == '' || signalRDetection == '') && (userAgent != UA && this.state.userdata.email.toLowerCase() == UE.toLowerCase())) {
                        userService.logout();
                        //window.location.href = window.location.href;
                        window.location.reload();
                    }
                    else {
                        localStorage.setItem('ch_cred_upl_dt', '');
                    }
                });
            });
        }
        catch (err) {
        }
    }
    GetLoggedInUserNotification = (roleEmail, roleType, id) => {
        try {
            userService.GetUserNotification(roleEmail, roleType, id).then(
                apidata => {
                    let acknowledgeList = apidata.filter((item) => item.isAcknowledge == 0);
                    if (apidata.length > 0) {
                        this.setState({ notification: apidata, isAcknowledge: acknowledgeList.length });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    render() {
        let profilename = "--";
        try {
            profilename = this.state._RoundPicName;
        } catch (error) {
            profilename = "--";
        }
        let logoUrl = '';
        if (window.location.host.toLowerCase() == "reporting.patientrxdiscount.com") {
            logoUrl = '/Patient-Rx-Discount.svg';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "glichealth.com" && window.location.host.toLowerCase() != "tempfilter-dev.glichealth.com") {
            logoUrl = '/GlicHealth_logo.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            logoUrl = '/Rxhacker_logo_new.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "honestdiscounts.com") {
            logoUrl = '/hdrx-logo.svg';
        } else {
            logoUrl = '/GlicHealth_logo.png';//'/hdrx-logo.svg';
        }
        var userrole, userName;
        try {
            if (userService.Check_LoggedIn_Status() != 'Login') {
                userrole = this.state.userdata.userrole;
                userName = this.state.userdata.username;
                try {
                    if (this.state.userdata.isBrokerTypeUser) {
                        userrole = "Broker";
                    }
                }
                catch (error) { }
            }
        } catch (error) { }
        const componentDecorator = (href, text, key) => (
            <a className="linkify__text" href={href} key={key} target="_blank">
                {text}
            </a>
        );
        return (
            <div className="header-section">
                <a href="javascript:void('0')" className="shape" onClick={this.sidebarToggle}>
                    <span className="">&nbsp;</span>
                    <span className="">&nbsp;</span>
                    <span className="">&nbsp;</span>
                </a>
                <a href="javascript:void('0')" className={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "glichealth.com" && window.location.host.toLowerCase() != "tempfilter-dev.glichealth.com" ? 'hdrx-logo glic-logo' : 'hdrx-logo'}><img src={window.location.origin + logoUrl} crossOrigin="anonymous" alt="" /></a>
                <div className="username_sec">
                    <a href="javascript:void('0')" className="bell-icon"><img src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxBell : Bell} alt="" />{this.state.isAcknowledge == 0 ? null : <span className="akCount">{this.state.isAcknowledge}</span>}</a>
                    <div className={this.state.notification.length > 4 ? 'notification addMore' : 'notification'} onFocusOut={this.test}>
                        <h2>Notifications{/* <span>{this.state.notification.length > 0 ? '(' + this.state.notification.length + ')' : null} </span>*/}</h2>
                        {
                            this.state.notification.length > 0 ?
                                <ul>
                                    {
                                        this.state.notification.map((data, index) => {
                                            return (
                                                <li className={data.isAcknowledge == 0 ? 'dark' : ''}>
                                                    <span className="user-icon">{window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? <img src={RxUser} alt="" /> : <img src={User} alt="" />}</span>
                                                    {
                                                        data.isClosed ?
                                                            <span className="content"><Linkify componentDecorator={componentDecorator}>{data.not_Content}</Linkify><span><span className="user-content">{data.not_Time} &nbsp;| &nbsp;{data.not_Owner} &nbsp;| &nbsp;</span><span class="beta-link"><span class="beta btn add-wholesaler">RESOLVED</span></span></span></span> :
                                                            <span className="content"><Linkify componentDecorator={componentDecorator}>{data.not_Content}</Linkify><span>{data.not_Time} &nbsp;| &nbsp;{data.not_Owner}</span></span>
                                                    }
                                                    {/*<img className="close-note" data-index={index} onClick={this.closeNotification} src={Close} alt="" />*/}</li>
                                            )
                                        })
                                    }
                                </ul> :
                                <div className="empty">
                                    <span className="empty-image">
                                        <img src={Empty} alt="empty" />
                                    </span>
                                    <span className="note">No Notifications</span>
                                    <span className="up">You are up to date</span>
                                </div>
                        }
                        {
                            /*
                            this.state.notification.length > 0 ?
                                <a href="javascript:void('0')" onClick={this.clearAll} className="clear-all">Clear All</a> :
                                null
                                */
                        }
                    </div>
                    <div className="ppic">{profilename}</div >
                    {/* <div className="ppic">{this.state.userdata.username.split(' ')[0].substring(this.state.userdata.username.split(' ')[0], 1) + '' + this.state.userdata.username.split(' ')[1].substring(this.state.userdata.username.split(' ')[1], 1)}</div >*/}
                    <div className="name">
                        <p>{userName}</p>
                        <p>{userrole}</p>
                    </div>
                    {
                        /*                          
                            <div className="dropdown-section">
                                <ul>
                                    <li><img src={Compliance} alt="" /> <a href={complianceUrl} target="_blank">Compliance Resources</a></li>
                                    <li className="logout"><img src={Logout} alt="" /> Logout</li>
                                </ul>
                            </div>
    
                         */
                    }
                </div>
            </div >
        )
    }
}
export default Header;